var bannerIsSliding = false;

var closeCart, selectCallback;

$(function() {
  var $header = $(".feature_image .header");

  $(document).on('click', '.edit_cart, .mm-opened #header', function(e) {
	closeCart();
    $('#nav').trigger("close");
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
  
  closeCart = function(){
	   $('#cart').trigger("close");
  }

  $('.search-toggle, .search-close').on('click', function(e) {

    if($('#search').hasClass("active")) {
      console.log('1');
      $('#search').hide().removeClass("active");
    } else {
      console.log('2');
      $('#search').show().addClass("active").find('input').focus();
    }

    e.stopPropagation();
    e.preventDefault();
    return false;
  })

  $(".icon-search").on('click', function(e) { $(this).parent('form').submit(); });

  Fancybox.bind('.lightbox');

  if ($(window).width() >= 959) {
    $('.thumbnail').hover(function(){ $('.quick_shop', this).show(); }, function(){ $('.quick_shop', this).hide(); })
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
    Fancybox.bind(".quick_shop", {
      width: modal_width,
      height: 'auto',
      autoSize: false,
      padding: 10,
      beforeShow: function(e) {
        var $gallery = $('.' + $(this.element).data('gallery'));
        var $product = $(this.element).data("fancybox-href");
        
          if($gallery.find('img').length == 1) { $gallery.find('.flex-direction-nav').hide() }
        
      }
    });
  }

   $('.mm-search input').keypress(function(e) {
    if(e.which == 13) {
      window.location = '/search?q=' + $(this).val() + '&type=product';
    }
  });

  
    Fancybox.bind("[data-fancybox]", {padding: 0, wrapCSS: 'gallery'});
  

  
    if ($(window).width() >= 768) {
      $('.thumbnail').hover(function() {
        $('.swatch span', $(this)).each(function() {
          if($(this).data("image").indexOf("no-image") == -1) {
            $('<img/>')[0].src = $(this).data("image");
          }
        });
      })
      $('.swatch span').hover(function() {
        if($(this).data("image").indexOf("no-image") == -1) {
          $(this).parents('.thumbnail').find('img').attr('src', $(this).data("image"));
        }
      });
    }
  

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });
  // $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });

  

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function() {
    if ($(window).width() <= 767) {
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
      }
    }
  });

  var $notify_form = $('.notify_form .contact-form');
  $notify_form.each(function() {
    var $nf = $(this);
    $nf.on("submit", function (e) {
      if($nf.find('.notify_email').val() != "") {
        $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $notify_form.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            }
        });
      } else {
        $nf.prev('.message').html("Please provide a valid email address.");
      }
      e.preventDefault();
    });
  });

  
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
  
  
  	const instafeed = document.getElementById("instafeed-gallery");
	if (instafeed && false) {
		(function(){
	        new InstagramFeed({
	            'username': 'biosculpturegelgb',
	            'container': instafeed,
	            'display_profile': false,
	            'display_biography': false,
	            'display_gallery': true,
	            'styling': true,
	            'items': 4,
	            'items_per_row': 4,
	            'margin': .5,
	        });
	    })();
	}
  


  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);

    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + escape(variant.options[i]) +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      
    }


    if (variant.price > 0) {
      $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')) + ' <span class="ex-vat">Excl. VAT</span>');
    } else {
      $('.current_price', $product).html("Free");
    }
	
    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))
      } else {
        $('.was_price', $product).text('')
      }

      if (variant.inventory_management && variant.inventory_quantity > 0) {
        
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      } else {
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
      }

      $('.sold_out', $product).text('');
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
    } else {
      var message = variant ? "Out of Stock" : "Unavailable";
      $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')));
      // $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
      $notify_form.fadeIn();
    }

  };
});

function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
